export default __webpack_public_path__ + "static/media/header_img_large.c379d223.png";